module.exports = __webpack_public_path__ + "static/0067-cfe095da9baa4e5f57b94e77b2007a07.png";